// extracted by mini-css-extract-plugin
export default {"mainContent":"build-system-simplified_mainContent__8k+zF"};